import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchInput, {createFilter} from 'react-search-input';
import { Navigate, Link } from 'react-router-dom';
import { getAllNotifications } from '../actions';
import Header from './Header';
import { Bars } from  'react-loader-spinner';
import logo from '../assets/logoHeader.png';
import { withRouter } from './withRouter';

const KEYS_TO_FILTERS = ['title'];
const columns = [
    {
        Header: 'ID',
        accessor: 'idNotification',
    },
    {
        Header: 'Título',
        accessor: 'title'
    },
    {
        id: 'acciones',
        Header: 'Acciones',
        Cell: row => (
            <div className="qrTableBtns">
                <Link
                    to={`/notification/${row.original.idNotification}`}
                    className="btn btn-primary btn-sm"
                >
                    <FontAwesomeIcon
                        icon='eye'
                        size='1x'
                    />
                </Link>
            </div>
        )
    }
];

let self = null;

class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            editing: true,
            filterText: ''
        };
        self = this;
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    componentDidMount() {
        this.props.getAllNotifications();
    }

    // renderAuthorizedUser = (row) => {
    //     if(row.original.authorized && !row.original.isAdmin){
    //         return <span>Autorizado</span>;
    //     }else if(!row.original.authorized && !row.original.isAdmin){
    //         return <span>No Autorizado</span>;
    //     }else if(row.original.isAdmin){
    //         return <span> - </span>;
    //     }
    // }



    handleNewNotificationClick = () => {
      return () => {
        this.props.navigate('/newNotification');
      };
    }

    renderUsersTable = () => {
      console.log(this.props)
        if(this.props.notifications.length === 0){
            return <Bars color="#17a2b8" height={30} width={30} />;
        }
        return (
            <ReactTable
                data={this.props.notifications}
                columns={columns}
                defaultPageSize={15}
                showPageSizeOptions={false}
                className="-striped"
                previousText= 'Anterior'
                nextText= 'Siguiente'
                loadingText= 'Cargando...'
                noDataText= 'No se encontraron filas'
                pageText= 'Pagina'
                ofText= 'de'
                rowsText= 'filas'
            />
        );
    }

    handleSearchChange(term) {
        this.setState({filterText: term});
    }

    renderBtnTxt = () => {
        return this.state.isAdmin ? 'Ver Usuarios' : 'Ver Administradores';
    }

    switchUsers = () => {
        this.setState({
            isAdmin: !this.state.isAdmin
        });
    }

    renderUsersList = () => {
        return (
            <div className="componentContainer">
                <Header />
                <div className="sectionContainer">
                    <div className="headerSection">
                        <div className="headerContent">
                            <div className="headerSectionTitle">Notificaciones</div>
                            <img src={logo} alt="AudioLibros" className="logoHeader"/>
                        </div>
                    </div>
                    <div className="usersColumns">
                        <div className="subHeader">
                            <SearchInput
                                placeholder="Buscar"
                                className="search-input appSearchInput"
                                onChange={this.handleSearchChange}
                            />
                        <div className="catBtnsSubHeaderHolder">
                            <button
                                className="btn btn-sm btn-success"
                                onClick={this.handleNewNotificationClick()}
                            >
                                Nueva notificación
                            </button>
                        </div>
                        </div>
                        {this.renderUsersTable()}
                    </div>
                </div>
            </div>
        );
    }
    renderComponent = () => {
        return this.props.auth ? (
            this.renderUsersList()
        ) : (
           <Navigate
                to={{
                    pathname: '/login',
                    state: { from: this.props.location }
                }}
            />
        );
    }

    render() {
        return this.renderComponent();
    }
}

const mapStateToProps = (state) => {

  console.log(state.notifications.notifications)
    return {
        auth: state.auth.authenticated,
        notifications: state.notifications.notifications
    };
};

export default connect(mapStateToProps, {getAllNotifications})(withRouter(Notifications));
